import { SelectableMenuItem } from '@/models';

export function getItemIds(items: SelectableMenuItem[]): string[] {
  return items.map(i => i && i.item && i.item.itemId);
}
